<template>
<v-card>
    <v-row class="ma-0 px-0 py-0" style="background: #3498db; color: white; cursor: pointer" align="center" justify="space-between" @click="isShown = !isShown">
        <v-col class="py-2" cols="10">
            <v-row align="center">
                <v-col class="py-1 item-title" sm="3">시장 구분</v-col>
                <v-col class="py-1">{{ marketSummaryText }}</v-col>
            </v-row>
            <v-row align="center">
                <v-col class="py-1 item-title" sm="3">
                    <span>업종</span>
                </v-col>
                <v-col class="py-1">{{ sectorSummaryText }}</v-col>
            </v-row>
        </v-col>
        <v-col class="text-right py-2" cols="auto">
            <v-btn icon small >
                <v-icon large color="white">{{ shownIcon }}</v-icon>
            </v-btn>
        </v-col>
    </v-row>

    <div v-show="isShown">
        <v-row class="ma-2" justify="end">
            <v-btn class="mx-2" small color="primary" @click="selectAll">전체 선택</v-btn>
            <v-btn class="mx-2" small color="red" @click="deselectAll">전체 해제</v-btn>
        </v-row>

        <v-divider />

        <v-card-text>
            <v-row align="center">
                <v-col sm="2" class="item-title">시장 구분</v-col>
                <v-col>
                    <v-row justify="start" align="center">
                        <span v-for="market in markets" :key="market.id">
                            <v-checkbox class="mr-3 my-0 pa-0" v-model="market.value" hide-details>
                                <template v-slot:label>
                                    <span style="color: black">{{ market.label }}</span>
                                </template>
                            </v-checkbox>
                        </span>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider />
        <v-card-text>
            <v-row align="start">
                <v-col sm="2" class="item-title">
                    <span>업종</span>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon class="ml-1" small v-on="on">help</v-icon>
                        </template>
                        <span>일부 업종은 코스피 혹은 코스닥에만 존재합니다</span>
                    </v-tooltip>
                </v-col>
                <v-col class="py-0">
                    <v-row align="start">
                        <v-col class="pa-0 ma-0" :cols="cols" v-for="sector in sectors" :key="`sector-${sector.id}`">
                            <v-checkbox class="my-1" v-model="sector.value" hide-details>
                                <template v-slot:label>
                                    <span style="color: black">{{ sector.label }}</span>
                                </template>
                            </v-checkbox>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
    </div>
</v-card>
</template>

<script>
import {
    db,
    auth
} from '@/firebase'
import {
    DateFormat
} from '@/mixins/date.js'
import {
    sectorData
} from '@/constants'

export default {
    name: 'sector-board',
    components: {},
    mixins: [
        DateFormat
    ],
    props: [
        'title'
    ],
    data() {
        return {
            isShown: false,
            kospiSelect: true,
            kosdaqSelect: true,
            markets: [{
                id: 0,
                value: true,
                label: '코스피'
            }, {
                id: 1,
                value: true,
                label: '코스닥'
            }],
            sectorsHolder: null,
        }
    },
    computed: {
        user() {
            return this.$store.getters.user
        },
        sectors() {
            if (!this.sectorsHolder) {
                this.sectorsHolder = []
                for (const [key, value] of Object.entries(sectorData)) {
                    this.sectorsHolder.push({id: key, label: value, value: true})
                }
            }

            return this.sectorsHolder
        },
        activeMarkets() {
            return this.markets.filter(m => m.value)
        },
        activeSectors() {
            return this.sectors.filter(s => s.value)
        },
        marketSummaryText() {
            if (this.markets.length == this.activeMarkets.length) return '전체'
            if (this.activeMarkets.length == 1 && this.activeMarkets[0].id == 0) return '코스피'
            if (this.activeMarkets.length == 1 && this.activeMarkets[0].id == 1) return '코스닥'
            return '없음'
        },
        sectorSummaryText() {
            if (this.sectors.length == this.activeSectors.length) return '전체'
            
            if (this.activeSectors.length == 0) return '없음'

            const labelMax = 4
            if (this.activeSectors.length > labelMax) {
                const labels = this.activeSectors.map(s => s.label)
                return labels.slice(0, labelMax).join(', ') + ` 외 ${labels.length - labelMax}개`
            } else {
                return this.activeSectors.map(s => s.label).join(', ')
            }
        },
        shownIcon() {
            return this.isShown ? 'arrow_drop_up' : 'arrow_drop_down'
        },
        cols() {
            return this.$store.state.mobile ? 3 : 2
        },
        activeMarketIdsText() {
            return this.activeMarkets.map(v => v.id).join(',')
        },
        activeSectorIdsText() {
            return this.activeSectors.map(v => v.id).join(',')
        },
    },
    created() {},
    async mounted() {},
    methods: {
        selectAll() {
            this.markets.forEach(m => m.value = true)
            this.sectors.forEach(s => s.value = true)
        },
        deselectAll() {
            this.markets.forEach(m => m.value = false)
            this.sectors.forEach(s => s.value = false)
        },
        kospiSelectChange(value) {
            this.kospiSectors.forEach(v => v.value = value)
        },
        kosdaqSelectChange(value) {
            this.kosdaqSectors.forEach(v => v.value = value)
        },
        validate() {
            if (this.activeMarkets.length <= 0) {
                this.$toasted.error('최소 1개 이상의 "시장 구분"을 선택해야 합니다')
                return false
            }

            if (this.activeSectors.length <= 0) {
                this.$toasted.error('최소 1개 이상의 "업종"을 선택해야 합니다')
                return false
            }

            return true
        }
    }
}
</script>